/** fake functions to legacy rendered news */
window.lzld = function () {
    return false;
}

window.ads = {
    printAds: function (params) {
        return false;
    }
}

window.pintoValoracion = false;
window.cargarValoracion = function () {
    var botonValoracion = Voonto.$('#enviar_valoracion');
    botonValoracion.hide(); // Se oculta el botón hasta que Gigya no se cargue correctamente
    window.pintoValoracion = true;
    return false;
}


// WEBPACK FOOTER //
// ./src/tracking/initFunctions.js